// extracted by mini-css-extract-plugin
export default {"watermarkRoot":"watermark-root--ZouOx8D9","watermarkInner":"watermark-inner--xfM2NWn2"};